import React from 'react';
import { FormField } from './FormField';
import { ExternalLinkIcon } from 'lucide-react';
interface RedirectLinkFieldProps {
  value: string;
  onChange: (value: string) => void;
}
export function RedirectLinkField({
  value,
  onChange
}: RedirectLinkFieldProps) {
  return <FormField label="Success redirect URL" tooltip="Where to redirect customers after a successful payment" data-id="element-1683">
      <div className="relative" data-id="element-1684">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1685">
          <ExternalLinkIcon size={16} className="text-gray-400" data-id="element-1686" />
        </div>
        <input type="url" className="block w-full pl-10 px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="https://example.com/thank-you" value={value} onChange={e => onChange(e.target.value)} data-id="element-1687" />
      </div>
      <p className="mt-1 text-xs text-gray-500" data-id="element-1688">
        Leave blank to use your default success page
      </p>
    </FormField>;
}